import { render, staticRenderFns } from "./chickenExDetail.vue?vue&type=template&id=37e378c1&scoped=true&"
import script from "./chickenExDetail.vue?vue&type=script&lang=js&"
export * from "./chickenExDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e378c1",
  null
  
)

export default component.exports